/**
 * UniversalNotificationsProvider Component
 * Wraps app to enable universal notifications across all pages
 * This should be placed inside Router but outside of individual pages
 * 
 * Supports HTTP-first mode by default (can be changed via env var or prop)
 */

import React from 'react';
import { NotificationProvider } from './NotificationContext';

/**
 * UniversalNotificationsProvider
 * Wraps the NotificationProvider from NotificationContext
 * Must be placed inside Router but outside of individual pages
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {string} props.mode - 'http' | 'websocket' | 'hybrid' (default: 'http' or from env)
 */
const UniversalNotificationsProvider = ({ children, mode }) => {
  // Determine mode: prop > env var > default to 'http'
  const notificationMode = mode || 
    process.env.REACT_APP_NOTIFICATION_MODE || 
    'http';

  // Just render children - NotificationProvider handles everything
  return (
    <NotificationProvider mode={notificationMode}>
      {children}
    </NotificationProvider>
  );
};

export default UniversalNotificationsProvider;
